export default __webpack_public_path__ + "static/media/chat.534a9625.svg";